import Vue from 'vue';
import {ConversationSummary, MessageContainer, UiMessage} from "@/components/communications/CommunicationInterfaces";
import MessageColumnMixin from "@/components/communications/cards/mixins/MessageColumnMixin";

export default Vue.component('message-category-card', {
  name: 'MessageCategoryCard',
  mixins: [ MessageColumnMixin ],
  props: {
    containerId: { type: Number }
  },
  watch: {
    inputMessages() {
      (this as any).setMessages(this.inputMessages);
    }
  },
  async created () {
    (this as any).mayReorder = true;
  },
  computed: {
    inputMessages(): ConversationSummary[] {
      return this.$store.getters['communication/getMessagesForContainer'](this.containerId);
    },
    headerColor (): string {
      switch (this.containerId) {
        case MessageContainer.Purple:
          return 'var(--color-purple)';
        case MessageContainer.Blue:
          return 'var(--color-blue)';
        case MessageContainer.Red:
          return 'var(--color-red)';
        case MessageContainer.Green:
          return 'var(--color-green)';
      }
      return '';
    },
    iconColorStyleObject (): any {
      return this.headerColor.length ? { color: '#FFF' } : {} ;
    }
  },
  methods: {
    async onDrop(dropResult: { removedIndex: number | null, addedIndex: number | null, payload: UiMessage }) {
      this.$emit('drop-occur',0);
      (this as any).moving = false;
      const { removedIndex, addedIndex, payload } = dropResult;
      if (removedIndex === null && addedIndex === null) {
        return;
      }
      if (removedIndex !== null) {
        this.$store.commit('communication/removeMessageFromContainer', { containerId: this.containerId, removedIndex });
      }
      if (addedIndex !== null) {
        this.$store.commit('communication/addMessageToContainer', { containerId: this.containerId, addedIndex, message: payload });
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/communications/cards/MessageCategoryCard.ts